import React from "react";
import { productFeatureManagementStore } from "../../../data/states/product_feature_management_store.ts";
import { Button, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, Typography } from "@mui/material";

type CreateProductFeatureSelectorProps = {
    selectedFeatureIds: string[],
    onSelect: (selectedIds: string[]) => void,
}


export const CreateProductFeatureSelector: React.FC<CreateProductFeatureSelectorProps> = (
    props: CreateProductFeatureSelectorProps,
) => {
    const { productFeatures, retry } = productFeatureManagementStore();

    const {
        selectedFeatureIds,
        onSelect,
    } = props;

    return productFeatures.when(
        (data) => {
            return <FormControl>
                <InputLabel id="feature-selector-label">Features</InputLabel>
                <Select
                    labelId="feature-selector-label"
                    multiple
                    value={selectedFeatureIds}
                    onChange={(event: SelectChangeEvent<string[]>) => {
                        if (Array.isArray(event.target.value)) {
                            onSelect(event.target.value);
                        }
                    }}
                    input={<OutlinedInput label="Features" />}
                >
                    {
                        data.map(
                            (item) => <MenuItem
                                key={item._id}
                                value={item._id}
                            >
                                {item.localisedValue}
                            </MenuItem>
                        )
                    }
                </Select>
            </FormControl>
        },
        (error) => {
            return <Button
                variant="outlined"
                onClick={retry}
            >
                RETRY PRODUCT FEATURE LOAD
            </Button>;
        },
        () => {
            return <Typography>Loading product features</Typography>
        },
    )
}